import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'BulletinDetails' })((theme) => ({
    summary: {
        marginTop: 24,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 16
        }
    },
    section: {
        marginTop: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    items: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    tags: {
        marginTop: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 0,
            marginBottom: 8
        }
    },
    navbar: {
        zIndex: 10,
        position: 'sticky',
        background: '#fff',
        top: 0,
        paddingTop: 24,
        paddingBottom: 8,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            paddingTop: 16
        }
    }
}));
